import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../utils/apiClient';

export const useReviewRequest = (pet) => {
  const [state, setState] = useState(null);
  const [error, setError] = useState('');
  const [version, setVersion] = useState(0);
  const channels = JSON.stringify(pet.review_channels || null);
  const retry = useCallback(() => setVersion(value => value + 1), []);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const response = await apiClient.get(`/review-requests/${pet.id}`);
        if (active) { setState(response.data); setError(''); }
      } catch (_) {
        if (active) setError('Unable to load review status.');
      }
    };
    load();
    const timer = setInterval(load, 3000);
    return () => { active = false; clearInterval(timer); };
  }, [pet.id, pet.review_sms, channels, version]);
  return { state, error, retry };
};